import { UserRedirectsEnum } from '@services/UserService';

import { OptionalRoutesEnum } from 'routes/enums';

const defaultOptionalsSubRoutes = {
  optionalRedirects: {
    [UserRedirectsEnum.MONTHLY_FEE_PREVIEW_REPORT]: false,
    [UserRedirectsEnum.COPARTICIPATION_PREVIEW_REPORT]: false,
    [UserRedirectsEnum.SUSPENDED_BENEFICIARY]: false,
  },
  optionalRoutes: {
    [OptionalRoutesEnum.BENEFICIARY_SERVICES]: false,
    [OptionalRoutesEnum.RESPONSIBILITY_LETTER]: false,
  },
};

export { defaultOptionalsSubRoutes };
